import { ApiConfig } from '../Api_Config/ApiEndpoints';
import { ApiCallGet, ApiCallPost } from '../Api_Config/ApiCall';

// Define interfaces for parameters
interface LoginParams {
  email: string;
  password: string; 
}

interface RegisterParams {
  country_code: string;
  email: string;
  password: string;
  confirm_password: string;
  referral_code: string;
  verification_code: string;
  firstName: string;
  lastName: string;
  userType: string;
}

interface ChangePasswordParams {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

interface GetCodeParams {
  email: string;
  type: string;
  otp: string;
}

interface ApiHeaders {
  'Content-Type': string;
  Authorization?: string;
}

const AuthService = {
  homeData: async (): Promise<any> => {
    const { baseAuth, homeData } = ApiConfig;
    const url = baseAuth + homeData;
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
    };
    return ApiCallGet(url, headers);
  },


  googleLogin: async (credential: string, userInfo?: { name: string, email: string, providerId: string, profile: string }, referralCode?: string | null) => {
    const { baseAuth, googleLogin } = ApiConfig;
    const url = baseAuth + googleLogin;
    const params = {
      token: credential,
      name: userInfo?.name,
      email: userInfo?.email,
      profile: userInfo?.profile,
      providerAccountId: userInfo?.providerId,
      referral_code: referralCode
    };
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
    };
    return ApiCallPost(url, params, headers);
  },

  login: async (email: string, password: string): Promise<any> => {
    const { baseAuth, login } = ApiConfig;
    const url = baseAuth + login;
    const params: LoginParams = {
      email: email,
      password,
    };
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
    };
    return ApiCallPost(url, params, headers);
  },

  register: async (
    signId: string,
    password: string,
    cPassword: string,
    otp: string,
    invitation: string,
    countryCode: string,
    firstName: string,
    lastName: string,
    userType: string
  ): Promise<any> => {
    const { baseAuth, register } = ApiConfig;
    const url = baseAuth + register;
    const params: RegisterParams = {
      country_code: countryCode,
      email: signId,
      password,
      confirm_password: cPassword,
      referral_code: invitation,
      verification_code: otp,
      firstName,
      lastName,
      userType,
    };
    console.log(params);
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
    };
    return ApiCallPost(url, params, headers);
  },

  changePassword: async (oldpassword: string, password: string, conPassword: string): Promise<any> => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
    const { baseAuth, changePassword } = ApiConfig;
    const url = baseAuth + changePassword;
    const params: ChangePasswordParams = {
      current_password: oldpassword,
      new_password: password,
      confirm_password: conPassword,
    };
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  getCode: async (signId: string, type: string, otp: string): Promise<any> => {
    const { baseAuth, getcode } = ApiConfig;
    const url = baseAuth + getcode;
    const params: GetCodeParams = {
      email: signId,
      type,
      otp,
    };
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
    };
    return ApiCallPost(url, params, headers);
  },

  //CRUD operations for swot analysis
  getSwotAnalysis: async (symbol: string): Promise<any> => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
    const { aiUrl, swotAnalysis } = ApiConfig;
    const url = aiUrl + swotAnalysis + `?symbol=${symbol}`;
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  // Save Stock Research Data
  getStockResearchData: async (symbol: string): Promise<any> => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
    const { apiUrl, stockResearchData } = ApiConfig;
    const url = apiUrl + stockResearchData + `/symbol/${symbol}`;
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },
  saveStockResearchData: async (data: any, symbol: string): Promise<any> => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
    const { apiUrl, stockResearchData } = ApiConfig;
    const url = apiUrl + stockResearchData + `/${symbol}`;
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    return ApiCallPost(url, data, headers);
  },
  updateStockResearchData: async (data: any): Promise<any> => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
    const { apiUrl, stockResearchData } = ApiConfig;
    const url = apiUrl + stockResearchData;
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    return ApiCallPost(url, data, headers);
  },

  simpleRegister: async (name: string, email: string, password: string, provider: string = "credentials"): Promise<any> => {
    const { baseAuth, register } = ApiConfig;
    const url = baseAuth + register;
    const params: any = {
      name,
      email,
      password,
      provider,
    };
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
    };
    return ApiCallPost(url, params, headers);
  },

  googleSignup: async (credential: string, userInfo?: { name: string, email: string, providerId: string, profile?: string }, referral?: string | null) => {
    const { baseAuth, googleLogin } = ApiConfig;
    const url = baseAuth + googleLogin;
    const params = {
      token: credential,
      name: userInfo?.name,
      email: userInfo?.email,
      profile: userInfo?.profile,
      providerAccountId: userInfo?.providerId,
      referral_code: referral,
      provider: "google"
    };
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
    };
    return ApiCallPost(url, params, headers);
  },
  verifyTransaction: async (transactionId: string) => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
    const { billingUrl, verifyTransaction } = ApiConfig;
    const url = billingUrl + verifyTransaction + `?sessionId=${transactionId}`;
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },
  getUserData: async (): Promise<any> => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
    const { baseAuth, getUserData } = ApiConfig;
    const url = baseAuth + getUserData;
    const headers: ApiHeaders = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  // Cancel subscription at end of billing period
  cancelSubscription: async (subscriptionId: string): Promise<any> => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN');
      const { billingUrl, cancelSubscription } = ApiConfig;
      const url = billingUrl + cancelSubscription;
      const headers : ApiHeaders = {
        'Content-Type': 'application/json',
        Authorization: token ?? '',
      };
      const params = {
        subscriptionId
      };
      return ApiCallPost(url, params, headers);
  },
  // Cancel subscription immediately
  cancelSubscriptionImmediate: async (subscriptionId: string): Promise<any> => {
    const token = sessionStorage.getItem('STOCK_AUTH_TOKEN');
      const { billingUrl, cancelSubscriptionImmediate } = ApiConfig;
      const url = billingUrl + cancelSubscriptionImmediate;
      const headers : ApiHeaders = {
        'Content-Type': 'application/json',
        Authorization: token ?? '',
      };
      const params = {
        subscriptionId
      };
      return ApiCallPost(url, params, headers);
  },
  getSubscriptionConfig: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { baseAuth, subscriptionConfig } = ApiConfig;
        const url = baseAuth + subscriptionConfig;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    }
};

export default AuthService;